const actionOCR = {
    GET_TEMPLATE_OCR : "GET_TEMPLATE_OCR",
    GET_TEMPLATE_OCR_TABLE : "GET_TEMPLATE_OCR_TABLE",
    LOAD_DATA_FROM_TEMPLATE : "LOAD_DATA_FROM_TEMPLATE",
    LOAD_DATA_BY_DOCUMENT_ID_AND_MULTIPART_FILE: "LOAD_DATA_BY_DOCUMENT_ID_AND_MULTIPART_FILE"
}

export default actionOCR;